import { action, observable, makeObservable } from "mobx";
import { Service } from "../../../models/Services/Service";
import ServiceAPI from "../api/ServiceAPI";
import { ServiceFilter } from "../../../models/Services/ServiceFilter";
import { OrderServices } from "../../../models/Order/OrderProduct";

export class ServiceStore {
  serviceAPI: ServiceAPI;
  limit: number;
  total_pages: number;
  total_count: number;
  services: Service[];

  constructor() {
    this.serviceAPI = new ServiceAPI();
    this.services = [];
    this.limit = 0;
    this.total_pages = 0;
    this.total_count = 0;

    makeObservable(this, {
      services: observable,
      getOrderServicesFromServices: action,
    });
  }

  getServices = async (params: ServiceFilter) => {
    try {
      this.services = [];
      const response = await this.serviceAPI.getServices(params);
      this.limit = response.limit;
      this.total_pages = response.total_pages;
      this.total_count = response.total_count;
      this.services = response.list;
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  getOrderServicesFromServices = (services: Service[]): OrderServices[] => {
    return services.map((service) => ({
      id: service.id,
      name: service.name,
      cost_price: service.cost_price,
      unit_price: service.selling_price,
      quantity: 1,
      avail_invoice_qty: 1,
      invoiced_quantity: 0,
      discount: 0,
      selling_price: service.selling_price,
      service_selling_price: service.selling_price,
      mrp: service.selling_price,
      tax_amount: 0,
      amount: 0,
      gst_percentage: service.gst_percentage,
      sku: service.sku,
      sac_code: service.sac_code,
      active: service.active,
      created_date: service.created_date,
      modified_date: service.modified_date,
    }));
  };
}
